import send from "@/utils/request";
// 机器人常见问题类型
export function agentQuestionType(params = {}) {
  return send({ url: '/ipp/v3/agent/question-type', method: 'POST', data: params });
}

// 机器人消息处理
export function agentMessage(params = {}) {
  return send({ url: '/ipp/v3/agent/message', method: 'POST', data: params });
}

// 机器人消息日志
export function agentMessageLogs(params = {}) {
  return send({ url: '/ipp/v3/agent/message-logs', method: 'POST', data: params });
}

